// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o0-c";
export var backButton = "_o0-4";
export var backIcon = "_o0-5";
export var chevronShortcut = "_o0-6";
export var container = "_o0-1";
export var editor = "_o0-8";
export var editorWrapper = "_o0-7";
export var prefix = "_o0-2";
export var searchIcon = "_o0-3";
export var suffix = "_o0-9";
export var suffixContent = "_o0-a";
export var suffixText = "_o0-b";
export var wrapper = "_o0-0";